import { render, staticRenderFns } from "./image-only-message.vue?vue&type=template&id=b4fe2398"
import script from "./image-only-message.vue?vue&type=script&lang=js"
export * from "./image-only-message.vue?vue&type=script&lang=js"
import style0 from "./image-only-message.vue?vue&type=style&index=0&id=b4fe2398&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports